<svelte:options />

<script>

    import { createEventDispatcher } from 'svelte';
    /**
     * @typedef {Object} Props
     * @property {any} data
     * @property {string} [label]
     * @property {boolean} [active]
     */
    let { data, label = '', active = false } = $props();

    const dispatch = createEventDispatcher();

    const maxTitleLength = 24;

    function handleResourceClick(_) {
        dispatch('loadResource', data);
    }

    function handleResourceClose(e) {
        dispatch('closeResource', {
            location: data.location,
            type: data.catalog,
            subType: data.subType,
            page: data.page,
            originalEvent: e,
            id: data.id,
        });
    }

    export {
    	data,
    	label,
    	active,
    };
</script>

{#if data}
    {@const title = data.title || label}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <div
        onclick={handleResourceClick}
        class="resource-item interactive {data.catalog === 'Page'
            ? 'activity'
            : ''} {active ? 'on' : ''}"
    >
        <div class="row">
            <span onclick={handleResourceClick}>
                <small>{data.subTypeLabel}</small>
                {#if title.length > maxTitleLength}
                    {title.substring(0, maxTitleLength)}&mldr;
                {:else}
                    {title}
                {/if}
            </span>
        </div>
        <div class="row">
            <i
                onclick={handleResourceClose}
                class="material-icons interactive"
                title="Options">close</i
            >
        </div>
    </div>
{/if}

<style>
    .resource-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        margin: 0.25rem 0.25rem 0 0;
        padding: 0.25rem 0.25rem 0.25rem 0.5rem;
        background-color: #3b3737;
        border-radius: 0.25rem 0.25rem 0 0;
        opacity: 0.4;
    }

    .resource-item:hover {
        opacity: 0.8;
    }

    .resource-item:last-of-type {
        margin-right: 0.5rem;
    }

    .resource-item span {
        font-size: 0.8rem;
        font-weight: 400;
        overflow: hidden;
    }

    .resource-item small {
        display: block;
        text-transform: uppercase;
        font-size: 0.6rem;
        font-weight: 600;
        color: rgb(74, 198, 255);
    }

    .resource-item.on {
        opacity: 1;
    }
    .row {
        display: flex;
        align-items: center;
    }

    i {
        color: rgba(255, 255, 255, 0.25);
        font-size: 1.1rem;
        padding: 0.3rem;
        border-radius: 10rem;
    }

    i.interactive:hover {
        background-color: rgba(255, 255, 255, 0.1);
        color: rgba(255, 255, 255, 0.75);
    }

    /*

    .activity{
        color:#333;
        background-color:rgb(74, 198, 255);
        box-shadow: 0 0.1rem 0.2rem rgba(0,0,0,0.25);
    }

    .activity small{
        color:#222;
    }

    .activity i{
        color:#333;
    }

    .activity i:hover{
        background-color: rgba(0,0,0,0.1);
    }
    */
</style>
